import { Credit } from "./Credit";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const Credits = _ref => {
  let {
    credits
  } = _ref;
  if (!credits || credits.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: credits.map((credit, index) => /*#__PURE__*/_jsx(Credit, {
      credit: credit,
      lastElement: index === credits.length - 1
    }, index))
  });
};